export const SERVER_FETCHED_NUMBER_WISHLIST_ITEMS = 12;
